"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Resource = function Resource($http, SERVER_URL, $filter) {
  "ngInject";

  return {
    getList: getList,
    get: get,
    post: post,
    put: put,
    putGeoPoints: putGeoPoints,
    postStrings: postStrings,
    putStrings: putStrings,
    remove: remove
  };

  function getList(modelName) {
    modelName = $filter('camelToKebab')(modelName);
    return $http.get(SERVER_URL + "/" + modelName + "-by-modified-date", {
      params: { modifiedDate: "2010-10-31T00:49:30.995Z" }
    });
  }

  function get(modelName, id) {
    modelName = $filter('camelToKebab')(modelName);
    return $http.get(SERVER_URL + "/" + modelName + "/" + id);
  }

  function put(modelName, data) {
    modelName = $filter('camelToKebab')(modelName);
    return $http.put(SERVER_URL + "/" + modelName, data);
  }

  function putGeoPoints(modelName, data) {
    return $http.put(SERVER_URL + "/" + modelName + "/geo-points", data);
  }

  function post(modelName, data) {
    modelName = $filter('camelToKebab')(modelName);
    return $http.post(SERVER_URL + "/" + modelName, data);
  }

  function postStrings(modelName, data) {
    modelName = $filter('camelToKebab')(modelName);
    return $http.post(SERVER_URL + "/" + modelName + "-strings", data);
  }

  function putStrings(modelName, data) {
    modelName = $filter('camelToKebab')(modelName);
    return $http.put(SERVER_URL + "/" + modelName + "-strings", data);
  }

  function remove(modelName, id) {
    modelName = $filter('camelToKebab')(modelName);
    return $http.delete(SERVER_URL + "/" + modelName + "/" + id);
  }
};
exports.default = Resource;


// WEBPACK FOOTER //
// ./client/app/services/resourceService/resource.service.js